<button
  (click)="save()"
  [ngClass]="{
    'small': small,
    'loading': submitting,
    'success': succeeded,
    'inactive': !edited,
    'indigo': color === 'indigo',
    'green': color === 'green'
  }"
>
  <span
    [innerText]="saveButtonText"
  ></span>
  <span class="icon"><i class="fa-regular fa-check"></i></span>
  <motn-spinner></motn-spinner>
</button>

@if (enableRevert) {
  <button
    (click)="revert()"
    [ngClass]="{
      'small': small,
      'inactive': !edited || submitting || succeeded
    }"
    [disabled]="submitting"
  >
    <span>Revert</span>
  </button>
}
